import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PageHeader, Loading, Confirm } from "@/components/common";
import { LabelBadge } from "@/components/badges";
import { CompareTable } from "@/components/RevisionEditor";
import { api, errMsg } from "@/lib/api";
import { fmtDateTime, periodLabel, REQ_KIND } from "@/lib/format";

function QueueCard({ r, i, onDone }) {
  const [reason, setReason] = useState("");
  const call = async (path, body, msg) => {
    try { await api.post(`/revision-requests/${r.id}/${path}`, body); toast.success(msg); window.dispatchEvent(new Event("revision-queue-changed")); onDone(); } catch (e) { toast.error(errMsg(e)); }
  };
  const no = `${r.invoice_number}${r.invoice?.revision ? ` R${r.invoice.revision}` : ""}`;
  return (
    <div className="border border-slate-300 bg-white rounded-sm p-3 space-y-2" data-testid={`queue-card-${i}`}>
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <b>{r.tenant_name}</b><span className="font-mono">{no}</span><span>· {r.customer_name}</span><span className="text-slate-500">· {periodLabel(r.period)}</span>
        <LabelBadge text={REQ_KIND[r.kind]} tone="blue" />
      </div>
      <div className="text-xs">Alasan: {r.reason}</div>
      <div className="text-xs text-slate-500">Diajukan {r.requested_by} · {fmtDateTime(r.requested_at)} · kedaluwarsa {fmtDateTime(r.expires_at)}</div>
      {r.kind === "proposal" && r.invoice && <CompareTable a={{ label: "Saat ini", lines: r.invoice.lines, total: r.invoice.total }} b={{ label: "Usulan", lines: r.proposed_lines, total: r.proposed_total }} testId={`queue-compare-${i}`} />}
      {r.mine ? <p className="text-xs text-amber-700">Pengajuan Anda sendiri. Harus diproses penyetuju lain.</p> : (
        <div className="flex flex-wrap gap-2">
          <Confirm title="Setujui pengajuan ini?" description={r.kind === "proposal" ? "Usulan langsung menjadi revisi baru." : "Pengaju mendapat izin edit 3 hari (satu kali simpan)."} onConfirm={() => call("approve", {}, "Disetujui")} testId={`queue-approve-${i}`}
            trigger={<Button className="h-11 flex-1 sm:flex-none bg-emerald-700 hover:bg-emerald-800" data-testid={`queue-approve-btn-${i}`}>Setujui</Button>} />
          <Input placeholder="Alasan tolak (min. 5)" value={reason} onChange={(e) => setReason(e.target.value)} className="h-11 w-full sm:w-64" data-testid={`queue-reject-reason-${i}`} />
          <Confirm title="Tolak pengajuan ini?" description="Invoice tetap seperti semula." onConfirm={() => call("reject", { reason }, "Ditolak")} testId={`queue-reject-${i}`}
            trigger={<Button disabled={reason.trim().length < 5} className="h-11 flex-1 sm:flex-none bg-rose-600 hover:bg-rose-700" data-testid={`queue-reject-btn-${i}`}>Tolak</Button>} />
        </div>
      )}
    </div>
  );
}

export default function RevisionQueue() {
  const [rows, setRows] = useState(null);
  const load = useCallback(async () => {
    try { setRows((await api.get("/revision-queue")).data); } catch (e) { toast.error(errMsg(e)); }
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  return (
    <div>
      <PageHeader sheet="ADMIN 06" title="Permintaan Revisi" subtitle="Pengajuan izin edit dan usulan perubahan invoice yang sudah disahkan, dari perusahaan yang menjadi wewenang Anda." />
      {!rows ? <Loading /> : rows.length === 0 ? <div className="text-center text-slate-500 py-10 border border-dashed rounded-sm" data-testid="queue-empty">Tidak ada permintaan revisi yang menunggu</div> : (
        <div className="space-y-3" data-testid="revision-queue">{rows.map((r, i) => <QueueCard key={r.id} r={r} i={i} onDone={load} />)}</div>
      )}
    </div>
  );
}
